jQuery(document).ready(function($) {
	$( '.gallery-photo-lightbox' ).swipebox();
});
